import formatDistance from './_lib/formatDistance';
import formatLong from './_lib/formatLong';
import formatRelative from './_lib/formatRelative';
import localize from './_lib/localize';
import match from './_lib/match';

/**
 * @type {Locale}
 * @category Locales
 *
 * // Name of the locale.
 * // Inside the parentheses - name of the country - if the locale uses the four letter code, e.g. en-US, fr-CA or pt-BR.
 * @summary Swahili locale.
 *
 * // Name of the language (used by https://date-fns.org/ website)
 * @language Swahili
 *
 */
const locale: Locale = {
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    // Index of the first day of the week.
    // Sunday is 0, Monday is 1, Saturday is 6.
    weekStartsOn: 0,

    // Nth of January which is always in the first week of the year. See:
    // https://en.wikipedia.org/wiki/Week#Week_numbering
    // http://www.pjh2.de/datetime/weeknumber/wnd.php?l=en
    firstWeekContainsDate: 1,
  },
};

export default locale;
